import { signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { UserInterface } from '@techniek-team/common';
import { Observable, of } from 'rxjs';
import { LyceoUser } from '../../models/lyceo-user.model';
import { user as userSignal } from './user.signal';

export class UserServiceMock<T extends UserInterface = LyceoUser> {
  public setUser = signal<T | undefined>(undefined);

  private user$ = toObservable(this.setUser);

  public readonly user = userSignal(this.setUser);

  public getUser: () => Promise<T | undefined> = jest.fn(() => {
    return Promise.resolve(this.setUser());
  });

  public currentUser: () => Observable<T> = jest.fn(() => {
    return of(this.setUser() as unknown as T);
  });

  public getRoles: () => Promise<string[]> = jest.fn(() => {
    return Promise.resolve(this.setUser()?.roles ?? []);
  });
}
